<div class="campagnes-page-container min-h-screen bg-white">
  <div class="campagnes-content-wrapper max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <!-- Crédit si utilisateur -->
      <div *ngIf="!isAdmin && !isSousAdmin" class="mb-4">
        <app-credit-disponible></app-credit-disponible>
      </div>


      <!-- Formulaire -->
      <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <form class="space-y-4">
          <!-- Première ligne : Client et Message unique -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Sélection client (Admin/Sous-admin) -->
            <div *ngIf="isAdmin || isSousAdmin" class="campagne-form-group">
              <label class="campagne-label">
                <span class="material-symbols-outlined text-sm mr-1.5">person</span>
                Client concerné
              </label>
              <select 
                class="campagne-input"
                [(ngModel)]="selectedClient"
                name="client"
                [class.border-red-300]="error.client">
                <option value="" disabled selected>Pour le client...</option>
                <option *ngFor="let client of clients" [value]="client._id">
                  {{ client.identifiant }}
                </option>
              </select>
              <p *ngIf="error.client" class="campagne-error">Merci de choisir le client</p>
            </div>

            <!-- Message unique -->
            <div class="campagne-form-group">
              <label class="campagne-label">
                <span class="material-symbols-outlined text-sm mr-1.5">chat_bubble</span>
                Message identique pour tous ?
              </label>
              <select 
                class="campagne-input"
                [(ngModel)]="nouveauMessage.messageUnique"
                name="messageUnique">
                <option value="1">Le message est le même</option>
                <option value="0">Le message est différent</option>
              </select>
            </div>
          </div>

          <!-- Référence campagne -->
          <div class="campagne-form-group">
            <label class="campagne-label">
              <span class="material-symbols-outlined text-sm mr-1.5">label</span>
              Référence de la campagne
            </label>
            <input 
              type="text"
              class="campagne-input"
              [(ngModel)]="nouveauMessage.nomCampagne"
              name="nomCampagne"
              placeholder="Référence de la campagne..."
              [class.border-red-300]="error.reference">
            <p *ngIf="error.reference" class="campagne-error">Merci de saisir la référence</p>
          </div>

          <!-- Planification - Design Premium Compact -->
          <div class="campagne-form-group">
            <label class="campagne-label">
              <span class="material-symbols-outlined text-sm mr-1.5">schedule</span>
              Planification de l'envoi
            </label>
            <div class="planification-toggle-container">
              <!-- Option Immédiat -->
              <div 
                class="planification-option"
                [class.active]="nouveauMessage.isScheduled === '0'"
                (click)="nouveauMessage.isScheduled = '0'">
                <div class="planification-option-content">
                  <div class="planification-icon-wrapper">
                    <span class="material-symbols-outlined planification-icon">flash_on</span>
                  </div>
                  <div class="planification-text">
                    <div class="planification-title">Envoi immédiat</div>
                    <div class="planification-subtitle">Démarrage automatique</div>
                  </div>
                </div>
              </div>
              
              <!-- Option Planifié -->
              <div 
                class="planification-option planification-option-scheduled"
                [class.active]="nouveauMessage.isScheduled === '1'"
                (click)="nouveauMessage.isScheduled = '1'">
                <div class="planification-option-content">
                  <div class="planification-icon-wrapper">
                    <span class="material-symbols-outlined planification-icon">calendar_today</span>
                  </div>
                  <div class="planification-text">
                    <div class="planification-title">Envoi planifié</div>
                    <div class="planification-subtitle">Définir une date</div>
                  </div>
                  
                  <!-- Champ date intégré à droite -->
                  <div 
                    class="planification-date-wrapper"
                    *ngIf="nouveauMessage.isScheduled === '1'"
                    (click)="$event.stopPropagation()">
                    <input 
                      type="datetime-local"
                      class="planification-date-input"
                      [(ngModel)]="nouveauMessage.schedule"
                      name="schedule"
                      [class.border-red-300]="error.schedule">
                  </div>
                </div>
                <p *ngIf="error.schedule" class="planification-date-error">Merci de saisir une date</p>
              </div>
            </div>
          </div>

          <!-- Message -->
          <div 
            class="campagne-form-group campagne-message-container transition-all duration-300 ease-in-out"
            *ngIf="nouveauMessage.messageUnique === '1'"
            [class.animate-fade-in]="nouveauMessage.messageUnique === '1'">
            <label class="campagne-label">
              <span class="material-symbols-outlined text-sm mr-1.5">message</span>
              Message à envoyer
            </label>
            <textarea 
              class="campagne-textarea"
              rows="4"
              placeholder="Message..."
              [(ngModel)]="nouveauMessage.message"
              name="message"
              (input)="control7Encoding()"
              [class.border-red-300]="error.message || error.tooLong"></textarea>
            <div class="flex items-center justify-between mt-1.5">
              <div>
                <span class="text-sm font-medium" [ngClass]="compterTaille() > describedText[0] ? 'text-red-600' : 'text-gray-600'">
                  {{ compterTaille() }} / {{ describedText[0] }} caractères
                </span>
                <span class="text-sm text-gray-500 ml-2">GSM {{ describedText[1] }}-bit</span>
              </div>
            </div>
            <p *ngIf="error.message" class="campagne-error">Merci de saisir votre message</p>
            <p *ngIf="error.tooLong" class="campagne-error">Le message est trop long</p>
          </div>

          <!-- Fichier -->
          <div class="campagne-form-group">
            <label class="campagne-label">
              <span class="material-symbols-outlined text-sm mr-1.5">upload_file</span>
              Fichier client (XLSX)
            </label>
            <div class="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-4 text-center transition-colors hover:border-blue-400">
              <div class="flex items-center justify-center gap-3">
                <div class="flex-1">
                  <p class="text-sm text-gray-600 mb-2 campagne-file-instruction transition-opacity duration-300 ease-in-out">
                    <span *ngIf="nouveauMessage.messageUnique === '1'" class="inline-block animate-fade-in">1 colonne avec les numéros sans titre</span>
                    <span *ngIf="nouveauMessage.messageUnique === '0'" class="inline-block animate-fade-in">2 colonnes sans titre : numéros + message</span>
                  </p>
                  <label class="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg cursor-pointer hover:bg-blue-700 transition-colors shadow-sm hover:shadow-md text-base">
                    <span class="material-symbols-outlined text-base mr-1.5">attach_file</span>
                    <span>Choisir un fichier</span>
                    <input 
                      type="file" 
                      (change)="fileChange($event)" 
                      class="hidden"
                      accept=".xlsx,.xls">
                  </label>
                </div>
                <div *ngIf="nouveauMessage.fileName" class="flex items-center gap-2 text-base text-gray-700 font-medium bg-white px-3 py-2 rounded-lg border border-gray-200">
                  <span class="material-symbols-outlined text-green-600 text-lg">check_circle</span>
                  <span class="max-w-xs truncate">{{ nouveauMessage.fileName }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="upload" class="mt-2 flex items-center gap-2 text-blue-600">
              <div class="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
              <span class="text-sm font-medium">Fichier en cours de téléchargement...</span>
            </div>
            <p *ngIf="error.destinataire" class="campagne-error">
              <span *ngIf="nouveauMessage.messageUnique === '1'">Merci d'importer des destinataires</span>
              <span *ngIf="nouveauMessage.messageUnique === '0'">Merci d'importer votre fichier client avec les numéros et messages</span>
            </p>
          </div>

          <!-- Bouton Créer -->
          <div class="flex justify-end pt-3 border-t border-gray-200">
            <button 
              type="button"
              class="campagne-btn-primary"
              (click)="premiereCreation()" 
              [disabled]="upload || isCreating">
              <span *ngIf="!isCreating" class="flex items-center gap-2">
                <span class="material-symbols-outlined text-base">add</span>
                <span>Créer</span>
              </span>
              <span *ngIf="isCreating" class="flex items-center gap-2">
                <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span>Création en cours...</span>
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
</div>
